import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  public loadingSubject = signal<boolean>(false);
  private requestCount = 0;

  show() {
    this.requestCount++;
    this.loadingSubject.set(true);
  }

  hide() {
    this.requestCount = Math.max(0, this.requestCount - 1);
    if (this.requestCount === 0) {
      this.loadingSubject.set(false);
    }
  }
}
